import { forwardRef, useCallback, useRef } from 'react';
import Anchor from './Anchor';
import { cn } from '@/ui/design-system/utils/cn';
import { mixpanelTrackLinks } from 'utils/app';
import { useLocation } from 'react-router';

// mixpanel-browser's track_links has no listener-removal API, so we attach
// once per element and read the latest props at click time via propsRef.
const trackedElements = new WeakSet();

// TODO: merge this with Link
const ExtLink = forwardRef(function ExtLink(
    { mixpanelContext = 'EXT_LINK', className, unstyled = false, ...restProps },
    ref,
) {
    const { pathname } = useLocation();
    const to = restProps.href;
    const propsRef = useRef();
    propsRef.current = { context: mixpanelContext, from: pathname, to };

    const setupTracking = useCallback(
        (el) => {
            if (typeof ref === 'function') ref(el);
            else if (ref) ref.current = el;

            if (el && !trackedElements.has(el)) {
                trackedElements.add(el);
                mixpanelTrackLinks(el, 'navigation', () => propsRef.current);
            }
        },
        [ref],
    );

    return (
        <Anchor
            ref={setupTracking}
            className={cn(
                !unstyled &&
                    'text-foreground underline hover:text-brand-primary',
                className,
            )}
            {...restProps}
        />
    );
});

export default ExtLink;
